document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('form[data-artist-submission]');
  if (!forms.length) return;

  forms.forEach((form) => {
    const { formId, successMessage, sheetUrl } = form.dataset;
    const container = form.closest(`.artist-submission-${formId}`) || form.parentElement;
    const status = container ? container.querySelector('[data-artist-status]') : null;
    const submitButton = form.querySelector('.push-btn');
    const submitSurface = submitButton?.querySelector('.push-btn__surface');

    const scrollToTop = () => {
      if (!container) return;
      const top = container.getBoundingClientRect().top + window.pageYOffset - 140;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    };

    const showStatus = (type, html) => {
      if (!status) return;
      status.classList.remove('is-success', 'is-error');
      if (type) status.classList.add(`is-${type}`);
      status.innerHTML = html;
      status.classList.add('is-visible');
      status.hidden = false;
      scrollToTop();
    };

    const clearStatus = () => {
      if (!status) return;
      status.classList.remove('is-success', 'is-error', 'is-visible');
      status.hidden = true;
      status.innerHTML = '';
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;

      clearStatus();

      if (submitButton) {
        submitButton.disabled = true;
        if (submitSurface) {
          submitSurface.dataset.originalText = submitSurface.dataset.originalText || submitSurface.textContent;
          submitSurface.textContent = 'Sending…';
        } else {
          submitButton.dataset.originalText = submitButton.dataset.originalText || submitButton.textContent;
          submitButton.textContent = 'Sending…';
        }
      }

      const formData = new FormData(form);
      const params = new URLSearchParams();
      formData.forEach((value, key) => params.append(key, value));

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: params,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
          redirect: 'manual',
          credentials: 'omit'
        });

        const isRedirect = response.type === 'opaqueredirect';
        if (isRedirect || (response.status >= 200 && response.status < 400)) {
          let message = `<span>${successMessage || 'Thanks for sending through your submission!'}</span>`;
          showStatus('success', message);
          form.reset();
        } else {
          let errorDetail = '';
          try {
            const json = await response.json();
            errorDetail = json?.error ? ` ${json.error}` : '';
          } catch (err) {
            errorDetail = ` ${response.status} ${response.statusText}`.trim();
          }
          throw new Error(errorDetail);
        }
      } catch (error) {
        const message = `We couldn't submit your form.${error?.message ? ` ${error.message}` : ''}`;
        showStatus('error', `<span>${message}</span>`);
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          if (submitSurface && submitSurface.dataset.originalText) {
            submitSurface.textContent = submitSurface.dataset.originalText;
          } else if (submitButton.dataset.originalText) {
            submitButton.textContent = submitButton.dataset.originalText;
          }
        }
      }
    });
  });
});
